import {
  constructNameFromTypeAndTerm,
  constructPeripheralNameFromTypeAndTerm
} from '@/pages/settings/bulk/helpers/utils';
import { Category, Manufacturer } from '../api/contracts/catalog/types';
import {
  FinanceModel,
  FinanceModelPcm,
  FinanceModelResponse,
  FinanceModelTypes,
  PeripheralFinanceModel,
  PeripheralFinanceModelResponse
} from '../api/contracts/financemodels';
import { Region } from '../api/contracts/region';

export const constructApiModelIdentifier = (model: FinanceModelResponse) =>
  `${constructNameFromTypeAndTerm(model.financeModelType as unknown as FinanceModelTypes, model.term).toLowerCase()}-${
    model.categoryId
  }${model.manufacturerId ? `-${model.manufacturerId}` : ''}`;

export const postProcessModel = (
  modelToProcess: FinanceModelResponse,
  regions: Region[],
  manufacturers: Manufacturer[],
  categories: Category[],
  allModels: FinanceModelResponse[]
) => {
  const category = categories.find(c => c.id === modelToProcess.categoryId);
  if (!category) throw new Error('Missing Manufacturer');

  const manufacturer = manufacturers.find(m => m.id === modelToProcess.manufacturerId);
  if (!manufacturer) throw new Error('Missing Manufacturer');

  const siblingModels = allModels.filter(
    m => constructApiModelIdentifier(m) === constructApiModelIdentifier(modelToProcess)
  );

  const pcms: FinanceModelPcm[] = [];

  regions.forEach(region => {
    const siblingModel = siblingModels.find(m => m.regionId === region.id);
    if (siblingModel) {
      pcms.push({
        region: region.code,
        value: siblingModel.pcmFactor
      });
    } else {
      pcms.push({
        region: region.code,
        value: 0
      });
    }
  });

  return {
    ...modelToProcess,
    category: category,
    manufacturer: manufacturer,
    name: constructNameFromTypeAndTerm(modelToProcess.financeModelType, modelToProcess.term),
    pcms
  } as FinanceModel;
};

export const postProcessPeripheralModel = (
  modelToProcess: PeripheralFinanceModelResponse,
  regions: Region[],
  allModels: PeripheralFinanceModelResponse[]
) => {
  const siblingModels = allModels.filter(
    m =>
      constructPeripheralNameFromTypeAndTerm(modelToProcess.peripheralFinanceModelType, modelToProcess.term) ===
      constructPeripheralNameFromTypeAndTerm(m.peripheralFinanceModelType, m.term)
  );

  const pcms: FinanceModelPcm[] = [];

  regions.forEach(region => {
    const siblingModel = siblingModels.find(m => m.regionId === region.id);
    if (siblingModel) {
      pcms.push({
        region: region.code,
        value: siblingModel.pcmFactor
      });
    } else {
      pcms.push({
        region: region.code,
        value: 0
      });
    }
  });

  return {
    ...modelToProcess,
    name: constructPeripheralNameFromTypeAndTerm(modelToProcess.peripheralFinanceModelType, modelToProcess.term),
    pcms
  } as PeripheralFinanceModel;
};
